import React, { useEffect, useState, Suspense } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { Table, Avatar, Row, Tag } from 'antd'
import '../../css/customer.scss'
import {
  fechactioncase,
  isNewActionCase,
  messageRowSelect,
} from '../../store/action/actioncases.action'
import {
  loginAsCustomer,
  loginAsCompany,
} from '../../store/action/profile.action'
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import moment from 'moment'
import util from '../../util/util'
import { constants } from '../../constants'
import { getCaseStats } from '../../store/action/actioncases.action'
import { stripMessageScope } from '../../util/messagefilter'

const ActionCaseTable = (props) => {
  var history = useHistory()

  console.log('props.profile ----------', props.profile.user.role)

  const userRole = props.profile.user.role
  useEffect(() => {
    // Always fetch on mount. This used to bail out until the clinics list was
    // in redux (a leftover of commented-out customerIds code below), which on
    // a direct load/refresh of /cases meant the list and stats never fetched
    // and the spinner never cleared.
    // stripMessageScope: the filters slice is shared with Clinic > Messages —
    // drop its Surgeon-Message scope if it leaked in. A legitimate clinic
    // scope is re-applied from history.location.state.customerid below.
    var filter = stripMessageScope(props.filters)
    var def = false
    if (history.location.state?.status)
      filter.status = [history.location.state?.status]
    if (history.location.state?.filters?.caseNumbers)
      filter.caseNumbers = history.location.state?.filters.caseNumbers
    if (history.location.state?.customerid)
      filter.customerIds = [history.location.state?.customerid]

    if (Object.keys(filter).length === 0 && filter.constructor === Object) {
      filter.status = [
        constants.ACTION_CASE_STATUS.ASSIGNED,
        constants.ACTION_CASE_STATUS.UNASSIGNED,
      ]
    }

    // if(props.customer?.customers ){
    //   filter.customerIds=getCustomerIds();
    // }
    props.fechactioncase(
      {
        metadata: { current: 1, pageSize: 20 },
        filters: filter,
        sorter: { field: 'lastUpdated', order: 'descend' },
      },
      undefined,
      true,
      false
    )
    props.getCaseStats(history.location.state?.customerid)
  }, [])

  useEffect(() => {
    if (props?.company?._id) {
      props.isNewActionCase(null, null, props?.company?._id)
    }
  }, [props?.company?._id])

  async function fetchActionCaseList(pagination, filters, sorter) {
    let filter =
      props.filters || {
        caseNumbers: history.location.state.filters.caseNumbers,
      } ||
      {}
    if (props.customer?.customers && !history.location.state?.customerid) {
      // filter.customerIds=getCustomerIds()
      filter = { ...filter, ...props.msgfilter }
    }
    // Both slices above are shared with Clinic > Messages — drop its
    // Surgeon-Message scope if it leaked in (same guard as the mount fetch),
    // so paginating/sorting Cases never re-applies the Messages scope.
    filter = stripMessageScope(filter)
    await props.fechactioncase(
      {
        metadata: pagination
          ? { current: pagination.current, pageSize: pagination.pageSize }
          : { current: 1, pageSize: 20 },
        filters: filter,
        sorter: {
          field: sorter.field ?? 'lastUpdated',
          order: sorter.order ?? 'descend',
        },
      },
      undefined,
      true,
      false
    )
  }

  const getCustomerIds = () => {
    return props.customer.customers.map((customer) => customer.id)
  }
  //console.log("HJJ",history.location.state.filters.caseNumbers)

  var handleRowClick = (record) => {
    const caseId = record.caseId
    history.push({ pathname: 'cases/' + caseId })
  }

  var handleRow = (record, rowIndex) => {
    return {
      onClick: (e) => {
        // Clicks on the selection checkbox column bubble up to the row —
        // selecting a case must not navigate into it.
        if (
          e.target &&
          e.target.closest &&
          e.target.closest('.ant-table-selection-column')
        )
          return
        handleRowClick(record)
      },
    }
  }
  var renderPatientName = (name, obj) => {
    const displayName = name ? name : 'N/A'
    return (
      <>
        {obj.isNew ? (
          <>
            {displayName} &nbsp;&nbsp;
            <Tag
              style={{
                borderRadius: '6px',
                fontWeight: 600,
                fontSize: '11px',
                lineHeight: '18px',
                padding: '0 8px',
                border: 'none',
              }}
              color='#d32f2f'
            >
              New
            </Tag>
          </>
        ) : (
          displayName
        )}
      </>
    )
  }
  var renderCaseNumber = (caseno, obj) => {
    const isNew =
      moment(moment.utc(obj.createdDate).toDate())
        .local()
        .isSame(moment(moment.utc(obj.lastViewedDate).toDate()).local()) ||
      moment(moment.utc(obj.updatedDate).toDate())
        .local()
        .isAfter(moment(moment.utc(obj.lastViewedDate).toDate()).local())

    return (
      <>
        {obj.isNew ? (
          <>
            {caseno} &nbsp;&nbsp;
            <Tag
              style={{
                borderRadius: '6px',
                fontWeight: 600,
                fontSize: '11px',
                lineHeight: '18px',
                padding: '0 8px',
                border: 'none',
              }}
              color='#d32f2f'
            >
              New
            </Tag>
          </>
        ) : (
          caseno
        )}
      </>
    )
  }

  const columns = [
    {
      title: 'Clinic',
      dataIndex: 'customerName',
      sorter: true,
      render: (record) => (record ? record : 'N/A'),
    },
    {
      title: 'Patient',
      dataIndex: 'patientName',
      sorter: true,
      render: (name, obj) => renderPatientName(name, obj),
    },
    {
      title: 'Subject',
      dataIndex: 'title',
      sorter: true,
      // Patient Technical cases are messages from the patient — show the
      // message's subject line. Every other type reads as its type name
      // (e.g. system-generated "New Patient" cases).
      render: (title, obj) =>
        title == constants.ACTION_CASE_TITLE.PATIENT_TECHNICAL && obj.summary
          ? obj.summary
          : title,
    },
    {
      title: 'Phone',
      dataIndex: 'patientPhone',
      render: (record) => (record ? record : 'N/A'),
    },
    {
      title: 'Last updated',
      dataIndex: 'lastUpdated',
      defaultSortOrder: 'descend',
      sorter: true,
      render: (date) => {
        return date
          ? moment(date).format('MM/DD/YYYY, h:mm a').toString()
          : moment().format('MM/DD/YYYY, h:mm a').toString()
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: true,
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      sorter: true,
    },
  ]

  if (userRole != constants.ROLE.COMPANY_HEALTHCOACH) {
    columns.splice(2, 0, {
      title: 'Assigned To',
      dataIndex: 'assignedToName',
    })
  }

  // The list slice is shared with Clinic > Messages, so its Surgeon Message
  // rows flash here for a moment until the fresh Cases fetch replaces them.
  // Cases never legitimately shows Surgeon Messages — drop them at render.
  const visibleCases = (props.actioncases || []).filter(
    (c) => c.title != constants.ACTION_CASE_TITLE.SURGEON_MESSAGE
  )

  return (
    <>
      <Table
        size={'large'}
        className={'custom-table'}
        columns={columns}
        dataSource={visibleCases}
        rowKey={(record) => record.caseId}
        rowSelection={{
          selectedRowKeys: props.selectedRequests?.key || [],
          onChange: (keys, rows) =>
            props.messageRowSelect({ key: keys, row: rows }),
        }}
        loading={props.isLoading}
        pagination={{
          current: props.metaData?.current,
          pageSize: props.metaData?.pageSize,
          total: props.total,
          showSizeChanger: true,
        }}
        onChange={fetchActionCaseList}
        bordered={false}
        onRow={handleRow}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  console.log('state ----mapStateToProps------>>>', state)

  return {
    profile: state.profile,
    actioncases: state.actioncase.actioncases,
    searchText: state.actioncase.searchText,
    metaData: state.actioncase.metadata,
    sorter: state.actioncase.sorter,
    filters: state.actioncase.filters,
    pagination: state.actioncase.pagination,
    isLoading: state.actioncase.isLoading,
    token: util.verifyToken(state.profile.token),
    company: state.profile.company,
    total: state.actioncase.total,
    customer: state.customer,
    msgfilter: state.message.filter,
    selectedRequests: state.message.selectedRequests,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fechactioncase: (params, select, ischeck, isNewMsg) => {
      console.log('params --------->> ', params)
      return dispatch(fechactioncase(params, select, ischeck, isNewMsg))
    },
    loginAsCompany: (params) => dispatch(loginAsCompany(params)),
    isNewActionCase: (customer, surgeonId, companyId) =>
      dispatch(isNewActionCase(customer, surgeonId, companyId)),
    getCaseStats: (params) => dispatch(getCaseStats(params)),
    messageRowSelect: (select) => dispatch(messageRowSelect(select)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionCaseTable)
